import React, { Component } from 'react';
import { connect } from 'react-redux';
import { buildUrl } from 'app/lib/tdAjax';
import { ResultStatuses } from '../constants';
import ResultUtils from '../utils/ResultUtils';
import {countBy} from 'lodash';

const COLUMNS = [...ResultUtils.RESULT_COLUMNS, { id: 'details', displayName: 'Actions' }];

// Displays value by default; can specify a renderer function that returns 'href' and/or
// 'value' properties
const COLUMN_RENDERERS = {
  internalMemberId(result) {
    return {
      href: `/members/${result.internalMemberId}`
    };
  },

  teladocGroupId(result) {
    return {
      href: `/groups/${result.teladocGroupId}`
    };
  },

  details(result) {
    if (result.status !== ResultStatuses.COMPLETE) {
      return null;
    }

    const params = {
      payer_id:         result.payerId,
      payer_cd:         result.payerCd,
      sku_cd:           result.skuCode,
      consult_cost:     result.consultCost,
      source_member_id: result.memberId,
      first_nm:         result.firstName,
      last_nm:          result.lastName,
      dob:              result.dateOfBirth,
      source_group_id:  result.groupId,
      bypass_cache:     false
    };
    return {
      href:  buildUrl('/rte_check', params),
      value: 'Details'
    };
  },

  responsibility(result) {
    if (result.status === ResultStatuses.COMPLETE) {
      return {
        value: result.responsibility
      };
    }

    // Show the status until it is complete
    return {
      value: result.status
    };
  }
};

export class TestResultsUnconnected extends Component {

  renderHeaders() {
    return COLUMNS.map(col => (
      <th key={col.id}>{col.displayName}</th>
    ));
  }

  renderRows() {
    const { results } = this.props;

    return results.map((result) => (
      <tr className="member" key={result.index}>
        {this.renderColumns(result)}
      </tr>
    ));
  }

  renderColumns(result) {
    return COLUMNS.map(col => (
      <td key={col.id} className={`result-column-${col.id}`}>
        {this.renderColumnValue(col.id, result)}
      </td>
    ));
  }

  renderColumnValue(id, result) {
    let value = result[id];
    let href;

    if (COLUMN_RENDERERS[id]) {
      const override = COLUMN_RENDERERS[id](result) || {};
      href = override.href;
      value = override.value || value;
    }

    if (!href) {
      return value;
    }

    return (
      <a
        className="test-result-link"
        href={href}
        target="_blank"
        rel="noreferrer noopener"
      >
        {value}
      </a>
    );
  }

  resultsStatus(results) {
    const counts = countBy(results, 'status');
    return `${counts[ResultStatuses.COMPLETE] || 0} / ${results.length}`;
  }

  render() {
    const { results } = this.props;

    if (!results) {
      return <div />;
    }

    return (
      <div className="rte-test-results">
        <h3>Test Results <span className="ml-3 font-normal">{this.resultsStatus(results)}</span></h3>
        <table className="person_list members">
          <thead>
            <tr>
              {this.renderHeaders()}
            </tr>
          </thead>
          <tbody>
            {this.renderRows()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(state => ({ results: state.rteTest.results }))(TestResultsUnconnected);
